// Client-side image preparation for AI recipe extraction.
// Downscales to a max longest edge, re-encodes as JPEG and enforces a
// base64 payload cap, stepping quality (then dimensions) down as needed.

const MAX_EDGE = 1600;
const MAX_BASE64_LENGTH = 2 * 1024 * 1024; // ~2MB of base64 payload
const QUALITY_STEPS = [0.8, 0.65, 0.5, 0.35];

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Could not read image')); };
    img.src = url;
  });
}

function drawToJpegBase64(img, maxEdge, quality) {
  const scale = Math.min(1, maxEdge / Math.max(img.naturalWidth, img.naturalHeight));
  const width = Math.max(1, Math.round(img.naturalWidth * scale));
  const height = Math.max(1, Math.round(img.naturalHeight * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  // Flatten transparency (PNG screenshots) to white before JPEG encode.
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(img, 0, 0, width, height);
  const dataUrl = canvas.toDataURL('image/jpeg', quality);
  return dataUrl.slice(dataUrl.indexOf(',') + 1); // strip the data: prefix
}

// File → { type: 'image', mediaType: 'image/jpeg', data: <base64> } per the AI contract.
export async function fileToAiImageSource(file) {
  const img = await loadImage(file);
  let edge = MAX_EDGE;
  for (let attempt = 0; attempt < 4; attempt += 1) {
    for (const quality of QUALITY_STEPS) {
      const data = drawToJpegBase64(img, edge, quality);
      if (data.length <= MAX_BASE64_LENGTH) {
        return { type: 'image', mediaType: 'image/jpeg', data };
      }
    }
    edge = Math.round(edge * 0.7);
  }
  throw new Error('Image is too large to process');
}
